<template>
  <div class="ppv-filter-group">
    <div class="ppv-filter-label">{{ $t("ppv.filters.triage") }}</div>
    <div class="ppv-chips-row">
      <PpvChip
        v-for="option in triageOptions"
        :key="option.value"
        variant="triage"
        :selected="isSelected(option.value)"
        :icon="option.icon"
        @click="onToggle(option.value)"
      >
        {{ $t(option.label) }}
      </PpvChip>
    </div>
  </div>
</template>

<script>
import PpvChip from '../shared/PpvChip.vue'

export default {
  name: 'PpvTriageFilter',
  components: { PpvChip },
  props: {
    selectedTriages: { type: Array, default: () => [] },
    triageOptions: { type: Array, required: true },
    onToggle: { type: Function, required: true },
  },
  methods: {
    isSelected(value) {
      return this.selectedTriages.includes(value)
    }
  }
}
</script>

<style scoped>
.ppv-filter-group {
  margin-bottom: 20px;
}
.ppv-filter-label {
  font-size: 11px;
  font-weight: 700;
  color: #8a96a8;
  letter-spacing: 0.08em;
  margin-bottom: 12px;
  text-transform: uppercase;
}
.ppv-chips-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
</style>
